import { ContentAdd } from '@fs/zion-icon'
import { IconButton } from '@fs/zion-ui'
import React, { useReducer } from 'react'
import { useTranslation } from 'react-i18next'
import { makeNewConclusion } from '../../person/PersonUtils'
import { deepCopy } from '../../../util/Utils'
import { DmcConclusionFact } from './DmcConclusionFact'

export default () => {}

export function DmcNewConclusionFact({ factOptions, associationOptions, onCreateCallback, onCancelCallback }) {
  const { t } = useTranslation()
  const { newConclusionFactState, newConclusionFactActions } = useNewConclusionFact(onCreateCallback, onCancelCallback)

  if (!newConclusionFactState.conclusionFact) {
    return null
  }

  return (
    <>
      {newConclusionFactState.open && (
        <DmcConclusionFact
          factConclusion={newConclusionFactState.conclusionFact}
          factOptions={factOptions}
          associationOptions={associationOptions}
          onSaveCallback={newConclusionFactActions.onCreate}
          onCancelCallback={newConclusionFactActions.onCancel}
          onDeleteCallback={newConclusionFactActions.toggleOpen}
          withChangeMessage={false}
          creating
        />
      )}
      {!newConclusionFactState.open && (
        <IconButton
          id="createFact"
          dmcflag="createNewFact"
          Icon={ContentAdd}
          color="green"
          onClick={() => newConclusionFactActions.toggleOpen()}
          emphasis="high"
          description={t('fact.createNew', 'Create New Fact')}
        />
      )}
    </>
  )
}

function useNewConclusionFact(onCreateCallback, onCancelCallback) {
  const initialState = {
    conclusionFact: makeNewConclusion('FACT'),
    open: false,
  }

  const reducer = (_, currentState) => deepCopy(currentState)

  const [newConclusionFactState, setNewConclusionFactState] = useReducer(reducer, initialState)

  const newConclusionFactActions = {
    setOpen: (open) => {
      newConclusionFactState.open = open
      newConclusionFactActions.updateNewConclusionFactState()
    },
    reset: () => {
      newConclusionFactState.conclusionFact = makeNewConclusion('FACT')
      newConclusionFactState.open = false
      newConclusionFactActions.updateNewConclusionFactState()
    },
    toggleOpen: () => {
      newConclusionFactActions.setOpen(!newConclusionFactState.open)
    },
    onCreate: (newConclusionFact) => {
      onCreateCallback(newConclusionFact)
      newConclusionFactActions.reset()
    },
    onCancel: (newConclusionFact) => {
      onCancelCallback && onCancelCallback(newConclusionFact)
      newConclusionFactActions.reset()
    },
    updateNewConclusionFactState: () => {
      setNewConclusionFactState(newConclusionFactState)
    },
  }

  return { newConclusionFactState, newConclusionFactActions }
}
